import { Box, Heading } from "@chakra-ui/react";

const ChartFrame = ({ children, height = "300px", title }) => {
  const hasTitle = Boolean(title);

  return (
    <Box width="100%" h={height} className="report-chart-frame">
      {hasTitle && (
        <Heading
          size="sm"
          fontWeight={400}
          fontSize="14px"
          color="#535353"
          mb="8px"
          lineHeight="1.25"
          textAlign="center"
          className="report-chart-title"
        >
          {title}
        </Heading>
      )}
      <Box h={hasTitle ? "calc(100% - 42px)" : "100%"} className="report-chart-viewport">
        {children}
      </Box>
    </Box>
  );
};

export default ChartFrame;
